import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import CheckboxV2 from '../checkbox-v2';

const Disabled = css`
  cursor: not-allowed;
  opacity: 0.3 !important;
`;

const PanelWrapper = styled.div`
  background-color: #fff;
  border: 1px solid
  ${props =>
      props.isSelected
        ? props.theme.color.primary.v200
        : props.theme.color.neutral.v300};
  border-radius: 4px;
  position: relative;
  width: 100%;

  ${props => props.disabled && Disabled}
`;

const PanelHeader = styled.div`
  border-bottom: 1px solid
  ${props =>
      props.isSelected
        ? props.theme.color.primary.v200
        : props.theme.color.neutral.v300};
  display: flex;
  padding: 32px 32px 24px;
`;

const RecommenedLabelWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: -10px;
`;

const RecommendedLabel = styled.div`
  background-color: ${props => props.theme.color.neutral.v100};
  margin: auto;
  border: 1px solid ${props =>
    props.isSelected
      ? props.theme.color.primary.v200
      : props.theme.color.neutral.v300};
  text-transform: uppercase;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-weight: bold;
  font-size: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  width: 128px;
  height: 20px;
  color: ${props => props.theme.color.primary.v200};
`;

const PanelHeaderRight = styled.span`
  display: inline-flex;
  margin-left: auto;
  margin-right: 0;
  padding-right: 1.25rem;
`;

const PanelHeaderTitle = styled.span`
  display: inline-flex;
  font-weight: 500;
  font-size: 24px;
  align-items: center;
  padding-left: 2rem;

  @media (min-width: ${props => props.theme.breakpoint.md}px) {
    padding-left: 116px;
  }
`;

const PanelBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 84%;
  padding: 24px 32px 32px;
`;

const PanelCheckboxNext = ({
  onChange,
  name,
  checkboxValue,
  checkboxText,
  children,
  className,
  disabled,
  panelBodyStyles,
  panelHeaderStyles,
  panelCheckBoxStyles,
  panelHeaderTitle,
  panelHeaderRight,
  showRightPanelHeader,
  showRecommended
}) => (
  <PanelWrapper className={className} isSelected={checkboxValue}>
    {showRecommended &&
      <RecommenedLabelWrapper>
        <RecommendedLabel isSelected={checkboxValue}>
          Recommended
        </RecommendedLabel>
    </RecommenedLabelWrapper>
    }
    <PanelHeader
      css={panelHeaderStyles}
      isSelected={checkboxValue}
      // onClick={() => onChange(name)}
    >
      <CheckboxV2
        disabled={disabled}
        round
        text={checkboxText || (checkboxValue ? 'Selected' : 'Select')}
        value={checkboxValue}
        name={name}
        onChange={() => onChange(name)}
        color="greenTwo"
        data-cv-test={`${name}Selection`}
        css={panelCheckBoxStyles}
      />

      {panelHeaderTitle !== null && (
        <PanelHeaderTitle>
          {panelHeaderTitle}
        </PanelHeaderTitle>
      )}

      {panelHeaderRight && showRightPanelHeader && (
        <PanelHeaderRight>
          {typeof panelHeaderRight === 'function'
            ? panelHeaderRight({ isSelected: checkboxValue, name })
            : panelHeaderRight}
        </PanelHeaderRight>
      )}
    </PanelHeader>

    <PanelBody isSelected={checkboxValue} css={panelBodyStyles}>
      {typeof children === 'function'
        ? children({ isSelected: checkboxValue, name })
        : children}
    </PanelBody>
  </PanelWrapper>
);

PanelCheckboxNext.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  disabled: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
  checkboxText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  checkboxValue: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  panelBodyStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  panelHeaderStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  panelCheckBoxStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  panelHeaderTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  panelHeaderRight: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  showRightPanelHeader: PropTypes.bool,
  showRecommended: PropTypes.bool
};

PanelCheckboxNext.defaultProps = {
  panelBodyStyles: [],
  panelHeaderStyles: [],
  panelCheckBoxStyles: [],
  panelHeaderTitle: null,
  children: null,
  disabled: false,
  className: null,
  checkboxText: null,
  checkboxValue: null,
  panelHeaderRight: null,
  showRightPanelHeader: false,
  showRecommended: false
};

export default PanelCheckboxNext;
